import { ApiError } from './utils/error';

export class HttpError extends ApiError {}

/**
 * HttpErrorResponse#status: 0
 */
export class ConnectError extends HttpError {
  constructor() {
    super('サーバーに接続できませんでした。');
  }
}

/**
 * HttpErrorResponse#status: 400
 */
export class BadRequestError extends HttpError {
  // BadRequestのサーバーレスポンスはは次の形になる
  // {[field_name: string]: string[]}
  // ただし、対応するfield_nameがない場合は"non_field_errors"というキーが使用される
  constructor(public readonly body: Record<string, string[]>) {
    let errorMessage = '';
    Object.entries(body).forEach(([field, value]) => {
      // 'non_field_errors' の場合はフィールド名を含めない
      const formattedValue = `${field === 'non_field_errors' ? '' : `${field}: `}${value.join('/')}\n`;
      errorMessage += formattedValue;
    });
    super(errorMessage);
  }
}

/**
 * HttpErrorResponse#status: 401
 */
export class UnauthorizedError extends HttpError {
  constructor(public readonly returnUrl: string) {
    super();
  }
}

/**
 * HttpErrorResponse#status: 403
 */
export class ForbiddenError extends HttpError {
  constructor() {
    super('ログインしてください。');
  }
}

/**
 * HttpErrorResponse#status: 404
 */
export class NotFoundError extends HttpError {
  constructor() {
    super('リソースが見つかりませんでした。');
  }
}

/**
 * HttpErrorResponse#status: 413
 */
export class TooLargePayloadError extends HttpError {
  constructor() {
    super('リクエストサイズが大きすぎます。');
  }
}

/**
 * HttpErrorResponse#status: 4XX
 */
export class ClientError extends HttpError {}

/**
 * HttpErrorResponse#status: 504
 */
export class GatewayTimeoutError extends HttpError {
  constructor() {
    super('タイムアウトしました。');
  }
}

/**
 * HttpErrorResponse#status: 5XX
 */
export class ServerError extends HttpError {
  constructor() {
    super('サーバーエラーが発生しました。');
  }
}
